/**
 * UNDO-TRASH-LIGHT — helper de textos para `registerUndo`.
 *
 * Centraliza las 3 cadenas compartidas de la pill (botón "Deshacer",
 * confirmación "Deshecho" y error "No se pudo deshacer") para no repetirlas en
 * cada call-site; solo el "done" (qué se hizo) varía por acción.
 */
import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import type { UndoMessages } from "./undo";

type TFn = (message: MessageDescriptor, values?: Record<string, unknown>) => string;

export function undoMessages(t: TFn, done: string): UndoMessages {
  return {
    done,
    undoLabel: t(msg`Undo`),
    undone: t(msg`Undone`),
    failed: t(msg`Couldn't undo that`),
  };
}
